<template>
    <div class="role">
        <div class="role-name">{{ info.name }}</div>
        <div class="desc">{{ info.desc }}</div>
        <div class="serial-num">
            <span class="serial-title">{{ info.title }}</span>
            <el-tag 
                v-for="item of managerlist"
                :key="item.id"
                size="small"
                @close="deleteManage(item.id)"
                :closable="true">
                {{ item.configValue }}
            </el-tag>
            <el-popover
                placement="right"
                width="200"
                trigger="click"
                v-model="visible">
                <el-input class="is-round"
                    size="small"
                    placeholder="请输入通用实体唯一标识号"
                    v-model="configValue"
                    @keyup.enter.native="addManage(configValue)"></el-input>

                <div style="text-align: right; margin-top: 10px">
                    <el-button
                        :disabled="!configValue" 
                        type="primary" 
                        size="mini" 
                        @click="addManage(configValue)">添加</el-button>
                </div>
                <el-button type="primary"
                    slot="reference"
                    size="small"
                    class="add-button"
                    icon="el-icon-plus"
                    plain
                    circle></el-button>
            </el-popover>
        </div>
        
    </div>
</template>
<script>

export default {
    props: {
        managerlist: Array,
        info: {
            default: () => {},
        }
    },
    data () {
        return {
            sysmanagerlist: [],
            configValue: '',
            visible: false,
        };
    },
    computed: {
        quser () {
            return this.$store.getters.quser;
        },
    },
    methods: {
        deleteManage(id) {
            this.$emit('delete', id);
        },
        addManage(configValue) {
            this.visible = false;
            this.$emit('add', configValue);
        },
    },
};
</script>
<style lang="less" scoped>
.role {
    margin-bottom: 40px;
    .role-name {
        font-size: 16px;
        font-weight: 600;
    }
    .desc {
        margin-top: 6px;
        color: #999;
    }
    .serial-num {
        font-size: 14px;
        margin-top: 16px;

        .add-button {
            padding: 2px;
        }

        /deep/.el-tag {
            margin-right: 10px;
        }

        .serial-title {
            font-size: 14px;
            font-weight: 600;
        }
    }
}
</style>